module.exports = __webpack_public_path__ + "img/OpenAccountIMG.2b58859a.jpg";